import { getVariationFillColor } from '@gonfalon/flag-variations/getVariationFillColor';
import type { List, Map } from '@gonfalon/immutable-shim/immutableShim';
import { Message } from '@gonfalon/messages/Message';
import { Variation } from '@gonfalon/ui/variation';
import clsx from 'clsx';
import nullthrows from 'nullthrows';

import { VARIATION_NOT_FOUND } from '#components/InstructionList/instructionListUtils';
import type { ExperimentRollout } from '#utils/flags/records/Rollout';
import type { Variation as variationType } from '#utils/flags/records/Variation';

import styles from './styles.module.css';

export const ExperimentRolloutDescription = ({
  rolloutWeights,
  variations,
  experimentAllocation,
}: {
  rolloutWeights: Map<string, number>;
  variations: List<variationType>;
  experimentAllocation: ExperimentRollout;
}) => {
  const renderVariation = (index: number) => (
    <Variation
      className={clsx(styles.variationInstructionEntry, 'u-ml-s')}
      key={index}
      color={getVariationFillColor(index)}
      value={nullthrows(variations.get(index), `expected a variation at index ${index}`).getDisplay()}
    />
  );

  let total = 0;

  return (
    <span className={styles.RolloutDescription}>
      {rolloutWeights
        .map((value, variationID) => {
          const variationIndex = variations.findIndex((v) => v._id === variationID);
          total += value;
          const percent = value / 1000;
          return (
            <span className={styles.rolloutVariation} key={variationID}>
              {variationIndex >= 0 ? renderVariation(variationIndex) : ` ${VARIATION_NOT_FOUND}`} ({percent}%),
            </span>
          );
        })
        .valueSeq()}
      <span className={styles.rolloutVariation}>
        {' '}
        <Message id="pendingChanges.experimentRollout.remaining" values={{ percent: (100000 - total) / 1000 }} />{' '}
        {typeof experimentAllocation.defaultVariation === 'number'
          ? renderVariation(experimentAllocation.defaultVariation)
          : VARIATION_NOT_FOUND}
      </span>
      <span className={styles.rolloutVariation}>
        {' '}
        {experimentAllocation.canReshuffle ? (
          <Message id="pendingChanges.experimentRollout.canReshuffle" />
        ) : (
          <Message id="pendingChanges.experimentRollout.cannotReshuffle" />
        )}
      </span>
    </span>
  );
};
